import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidatorService } from '@services/validator.service';
import { ApiClientService } from '@smartmoving/sm-shared-lib';
import { ForgotPasswordForm } from '@generated/ForgotPassword/forgot-password-form';

@Component({
  selector: 'sm-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  standalone: false
})
export class ForgotPasswordComponent implements OnInit {
  resetForm: FormGroup;
  showSuccess = false;
  showError = false;
  isSubmitting = false;

  constructor(private readonly formBuilder: FormBuilder,
              private readonly apiClient: ApiClientService) {
  }

  ngOnInit() {
    this.isSubmitting = false;
    this.showSuccess = false;
    this.showError = false;
    this.resetForm = this.formBuilder.group({
      emailAddress: ['', [Validators.required, ValidatorService.isValidMailFormat]],
    });
  }

  ionViewWillEnter() {
    this.ngOnInit();
  }

  async submit() {
    if (this.resetForm.invalid) {
      this.resetForm.markAllAsTouched();
      return;
    }

    const formValue: ForgotPasswordForm = this.resetForm.value;
    await this.apiClient.postAll([{ url: 'forgot-password/request-reset', body: formValue }], x => this.isSubmitting = x);
    this.showSuccess = true;
  }
}
